<ng-container *ngIf="hasAdditionalQuestionAnswers">
  <button
    *ngIf="display === 'menu'"
    mat-menu-item
    type="button"
    (click)="additionalQuestionsClicked()"
  >
    <mat-icon>quiz</mat-icon>
    {{ "Additional questions" | translate }}
  </button>

  <div *ngIf="display === 'quick'" class="field-wrapper additional-questions-quick-link">
    <button
      type="button"
      class="additional-questions-quick-button"
      mat-stroked-button
      (click)="additionalQuestionsClicked()"
    >
      <mat-icon>quiz</mat-icon>
      {{ "Additional questions" | translate }}
    </button>
  </div>
</ng-container>
